import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import $ from 'jquery';

@Directive({
    selector: '[appClickOutsideAssignBlock]',
})
export class ClickOutsideAssignBlockDirective {
    constructor(private _elementRef: ElementRef) {}

    @Output() appClickOutsideAssignBlock = new EventEmitter();

    @HostListener('document:click', ['$event.target'])
    onClick(targetElement) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (
            !clickedInside &&
            !$(targetElement).closest('.assign-block').length &&
            !$(targetElement).closest('typeahead-container').length
        ) {
            this.appClickOutsideAssignBlock.emit(null);
        }
    }
}
